/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SparkApi from "../../api/SparkApi";
import { useNavigate, useParams } from "react-router-dom";
const RackCreate = (props) => {
  const paramid = useParams();
  const navigate = useNavigate();
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [rackRecord, setRackRecord] = useState({
    name: "",
    warehouse_id: props?.recordId || null,
    status: "Active",
    description: "",
  });
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    if (props.rackRec) {
      setRackRecord(props.rackRec);
    }
  }, [props.rackRec]);

  useEffect(() => {
    async function fetchAllWarehouses() {
      try {
        const warehouses = await SparkApi.fetchWarehouse();

        const wareHouseRecords = warehouses.map((sub) => ({
          value: sub?.id,
          label: sub?.name,
          factory_name: sub?.factory_name,
        }));
        setWarehouseOptions(wareHouseRecords);
      } catch (error) {
        console.error("Error fetching warehouses:", error);
      }
    }
    fetchAllWarehouses();
  }, []);

  const handleChange = (e) => {
    setRackRecord({ ...rackRecord, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rackRecord.name.trim() && rackRecord.warehouse_id) {
      try {
        let result;
        setDisableButton(true);
        if (rackRecord.id) {
          result = await SparkApi.saveRack(rackRecord);
        } else {
          result = await SparkApi.createRack(rackRecord);
        }

        if (result.success) {

          if (typeof props?.fetchRacks === "function") {
            await props?.fetchRacks({ message: result.message });
          } else {
          }

          if (typeof props?.fetchWarehouseData === "function") {
            props?.fetchWarehouseData({ message: result.message });
          } else {
          }

          toast.success(result.message);

          setTimeout(() => {
            props?.onHide();
            setDisableButton(false);
            setRackRecord({
              name: "",
              warehouse_id: "",
              status: "",
              description: "",
            });
            props?.recordId
              ? navigate(`/warehouse/${props.recordId}`)
              : navigate(`/racks`);
          }, 900);
        } else {
          setDisableButton(false);
          toast.error(result.message);
        }
      } catch (error) {
        // toast.error(error.message || "An unexpected error occurred");
        toast.error(error.response.data.message);
      }
    } else {
      toast.error("Missing required fields");
    }
  };

  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={props.onHide} className="view-form-header" centered>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.rackRec ? `Edit Rack: ${props.rackRec.name}` : "Create Rack"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form noValidate>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicName"
                      >
                        Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        placeholder="Enter name"
                        value={rackRecord.name}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mx-3" controlId="formBasicSelect">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={rackRecord.status}
                        onChange={handleChange}
                        style={{ height: "36px" }}
                      >
                        <option value="" disabled>
                          --Select status--
                        </option>
                        <option value="Active" selected>
                          Active
                        </option>
                        <option value="Inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    {warehouseOptions && (
                      <Form.Group className="mx-3">
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWarehouse"
                        >
                          Warehouse name
                        </Form.Label>
                        <Form.Select
                          name="warehouse_id"
                          value={rackRecord?.warehouse_id}
                          disabled={props?.recordId}
                          onChange={handleChange}
                          required
                        >
                          <option value="" selected disabled>
                            --- Select Warehouse ---
                          </option>
                          {paramid && paramid.id
                            ? warehouseOptions.map((wrHouse) => {
                              if (wrHouse.value === paramid.id) {
                                return (
                                  <option
                                    key={wrHouse.value}
                                    value={wrHouse.value}
                                  >
                                    {wrHouse.label}-{wrHouse?.factory_name}
                                  </option>
                                );
                              }

                              if (rackRecord.id === paramid.id) {
                                return (
                                  <option
                                    key={wrHouse.value}
                                    value={wrHouse.value}
                                  >
                                    {wrHouse.label}-{wrHouse?.factory_name}
                                  </option>
                                );
                              }
                              return null;
                            })
                            : warehouseOptions.map((wrHouse) => {
                              return (
                                <option
                                  key={wrHouse.value}
                                  value={wrHouse.value}
                                >
                                  {wrHouse.label}-{wrHouse?.factory_name}
                                </option>
                              );
                            })}
                        </Form.Select>
                      </Form.Group>
                    )}
                  </Col>

                  <Col lg={12}>
                    <Form.Group
                      className="mx-3"
                      controlId="formBasicDescription"
                    >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicDescription"
                      >
                        Description
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        as="textarea"
                        name="description"
                        placeholder="Enter description"
                        value={rackRecord.description}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={disableButton} variant="success btn-sm" onClick={handleSubmit}>
          {props?.parent?.section_id ? "Update" : "Save"}
        </Button>
        <Button onClick={props.onHide} variant="light btn-sm">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RackCreate;
